// extracted by mini-css-extract-plugin
export default {"root":"classes_root__W-3Gl","left-part":"classes_left-part__xmX-z","right-part":"classes_right-part__FkeJr"};